import { useApiClient } from "@myplant-io/utils/api";
import { useMutation, useQueryClient } from "react-query";
import { MemoryItem } from "../types";

export function useMemoryUpdate() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation(
    ({ id, text }: { id: string; text: string }) => {
      return client.fetch<MemoryItem>(`/api/memory/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ text }),
      });
    },

    {
      async onSettled() {
        await queryClient.invalidateQueries({
          queryKey: ["memory"],
        });
      },
    }
  );
}
